// Centralized env access. Vite injects import.meta.env.VITE_* at build time.

const env = import.meta.env;

export const API_URL = env.VITE_API_URL ?? 'http://localhost:3001/api';
// The unare-agent Worker's origin (no /api): the chat runs there for the people the
// agent-runtime flag moves. Empty keeps every chat on core.api.
export const AGENT_URL = (env.VITE_AGENT_URL ?? '').replace(/\/+$/, '');
export const CLERK_PUBLISHABLE_KEY = env.VITE_CLERK_PUBLISHABLE_KEY ?? '';
// PostHog — public project key only (no secret client-side). Host is config-driven:
// direct PostHog US ingestion in dev, repointed to the first-party proxy for release.
export const POSTHOG_KEY = env.VITE_POSTHOG_KEY ?? '';
export const POSTHOG_HOST = env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com';
export const CHAT_DEBUG_MODE = env.VITE_CHAT_DEBUG_MODE === 'true';
export const PLUGGY_DEBUG_MODE = env.VITE_PLUGGY_DEBUG_MODE === 'true';
export const APP_ENV = (env.VITE_ENV ?? '').toLowerCase();
// DEV-only local override: feature-flag keys forced ON without PostHog (comma-separated).
// Consumed by the telemetry facade, which ignores it in production builds. Set in .env.local.
export const FORCED_FEATURE_FLAGS = (env.VITE_FEATURE_FLAGS ?? '')
  .split(',')
  .map((flag) => flag.trim())
  .filter(Boolean);
